import { object, string } from 'yup';
import { TFunction } from 'i18next';

export function makeRequestInfoSchema(t: TFunction) {
  return object().shape({
    a: string().required(t('form.required')),
    b: string(),
    c: string(),
  });
}
